import { Directive, ElementRef, AfterViewInit, inject, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appAnimate]',
  standalone: true
})
export class AnimateDirective implements AfterViewInit, OnDestroy {
  private el = inject(ElementRef);
  private observer: IntersectionObserver | undefined;
  
  // Default delay reduced to 0 so the CSS (1.5s duration) controls the smoothness immediately upon scroll.
  // Use [delay]="200" in HTML only when staggering lists.
  @Input() delay = 0;
  @Input() threshold = 0.15;
  @Input() rootMargin = '0px 0px -50px 0px';

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    element.classList.add('fade-up');
    
    if (this.delay > 0) {
      element.style.transitionDelay = `${this.delay}ms`;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add class immediately when in view
          element.classList.add('is-visible');
          this.observer?.unobserve(element);
        }
      });
    }, { 
      threshold: this.threshold, 
      rootMargin: this.rootMargin 
    });

    this.observer.observe(element);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}